// import { get, post, put, del, upload } from './request'
import { get, post } from './request'


// FormData格式的登录
export const loginFormData = (formData) => post('/_Account/Login', formData)

//电影场次
export const MovieShowtimesFormData = (formData) => post('/ChangCiApi/QueryChangCi', formData)

//个人预约
export const PersonalReservation = (data) => post(`/YuYueApi/GetYuYueByCurrentUser`,data)

//电影预约
export const MovieReservation = (payload) => post('/YuYueApi/YuYueMore2', payload)

//电影列表
export const MovieListFormData = (formData) => post('/DianYingApi/QueryDianYing', formData)

//电影详情
export const GetMovieDetails = (id) => get(`/DianYingApi/GetDianYing?id=${id}`,)

//获取图片流文件
export const GetFile = (id) => get(`/_file/GetFile/${id}`, {}, {
  responseType: 'blob' // 指定响应类型为 blob
})

//获取个人场次信息
export const GetUserInfo = (data) => post('/_Account/GetUserPoint',data)

//退出登录
export const LogOut = () => get('/_Account/Logout')

//查询观影人
export const SearchForViewerInformation = (data) => post('/ZuYuanApi/GetZuChengYuanByCurrentUser',data)

//添加观影人
export const AddViewerInformation = (data) => post('/ZuYuanApi/TianJiaZuYuan', data)

//修改观影人
export const ModifyViewerInformation = (formData) => post('/ZuYuanApi/XiuGaiZuYuan', formData)

//删除观影人
export const DeleteViewerInformation = (formData) => post('/ZuYuanApi/ShanChuZuYuan', formData)

//删除观影人
export const GetOpenId = (code) => get(`/Wx/GetOpenId?code=${code}`)

//支付记录
export const PaymentRecords = (index, size) => get(`/ShouKuanJiLuApi/GetShouKuanJiLuByCurrentUser?pageindex=${index}&pagesize=${size}`)

//获取用户名
export const GetInfo = (data) => get('/wechat/user/GetInfo',data)


export default {
  // auth
  loginFormData,
  MovieListFormData,
  GetMovieDetails,
  GetFile,
  MovieShowtimesFormData,
  MovieReservation,
  PersonalReservation,
  GetUserInfo,
  LogOut,
  SearchForViewerInformation,
  AddViewerInformation,
  ModifyViewerInformation,
  DeleteViewerInformation,
  GetOpenId,
  PaymentRecords,
  GetInfo
}

